// extracted by mini-css-extract-plugin
export var chartBox = "transition-scores-module--chart-box--8dc15";
export var container = "transition-scores-module--container--91620";
export var errorText = "transition-scores-module--error-text--a7120";
export var loader = "transition-scores-module--loader--2093c";
export var loading = "transition-scores-module--loading--3b34c";